// Packages
import PropTypes from 'prop-types';

// other
import './styles.css';

function BTDPagination({ currentPage, maxPagesToShow, totalPages, onChange, style }) {

    const handlePageChange = (newPage) => {

        if (newPage >= 1 && newPage <= totalPages) {

            onChange(newPage);
        }
    };

    const renderPageNumbers = () => {

        const pageNumbers = [];

        let startPage = Math.max(1, currentPage - maxPagesToShow);
        let endPage = Math.min(totalPages, currentPage + maxPagesToShow);

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li
                    key={i}
                    className={`BTDPagination__list__number ${currentPage === i ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                    >
                    {i}
                </li>
            );
        }
        return pageNumbers;
    };

    return (
        <div className="BTDPagination" style={style}>

            <div
                className={`BTDPagination__button BTDPagination__button-prev ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />

            <ul className="BTDPagination__list">
                {renderPageNumbers()}
            </ul>

            <div
                className={`BTDPagination__button BTDPagination__button-next ${currentPage === totalPages ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />

        </div>
    );
}

BTDPagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    maxPagesToShow: PropTypes.number,
    totalPages: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    style: PropTypes.object
};

BTDPagination.defaultProps = {
    currentPage: PropTypes.number,
    maxPagesToShow: 5,
    totalPages: PropTypes.number,
    onChange: () => {alert('onChange is not set!')},
    style: {}
}

export default BTDPagination;
